<template>
	<div class="ui basic">
		<semantic-loading :active="isLoading" :text="$t('globals.loaders.loading')"></semantic-loading>

		<div class="ui">
			<h1 class="ui zw compact header">
				{{ $t('pages.archive.title') }}
			</h1>
		</div>
		<div class="ui divider"></div>

		<table class="ui celled padded table">
			<thead>
			<tr>
				<th>#</th>
				<th>{{ $t('pages.archive.table.name') }}</th>
				<th>{{ $t('pages.archive.table.interval') }}</th>
				<th>{{ $t('pages.archive.table.price') }}</th>
				<th>{{ $t('pages.archive.table.last_payment') }}</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="subscription in subscriptions">
				<td>{{subscription.id }}</td>
				<td>{{ subscription.product.name }}</td>
				<td>{{ getInterval(subscription.pricing) }}</td>
				<td>
          <span v-if="subscription.pricing">
            {{ subscription.pricing.price | money }}
          </span>
          <span v-else>
            -
          </span>
        </td>
				<td>{{ subscription.transaction_date }}</td>
			</tr>
			</tbody>
			<tfoot>
			<tr>
				<th colspan="6">
					<div class="ui right floated pagination menu">
						<a class="icon item" :class="{ 'disabled' : pagination.current_page === 1 }" @click="gotoPrevPage">
							<i class="left chevron icon"/>
						</a>
						<a class="item" :class="{ 'active' : pagination.current_page === page }" v-for="page in pagination.last_page" @click="gotoPage(page)">{{ page }}</a>
						<a class="icon item" :class="{ 'disabled' : pagination.current_page === pagination.last_page }" @click="gotoNextPage()">
							<i class="right chevron icon"/>
						</a>
					</div>

					<div class="ui right floated menu">
						<semantic-form-dropdown v-model="pagination.per_page" :options="[{id: 15, name: '15'},{id: 25, name: '25'},{id: 50, name: '50'}]" @dropdown-selected="changePerPage"></semantic-form-dropdown>
					</div>
				</th>
			</tr>
			</tfoot>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'Archive',

		metaInfo () {
			return {
				title: this.$t('pages.archive.meta')
			}
		},

		data () {
			return {
				isLoading: false,

				subscriptions: [],
				pagination: {
					current_page: 1,
					per_page: 15,
					total: 0,
					last_page: 0
				},
				canceltoken: null
			}
		},

		computed: {
			merchants () {
				return this.$store.getters.Merchants
			},

			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		},

		watch: {
			activeMerchant () {
				this.fetchInactiveSubscriptions()
			}
		},

		mounted () {
			this.fetchInactiveSubscriptions()
		},

		methods: {
			fetchInactiveSubscriptions () {
				if (this.cancelToken) {
					this.cancelToken.cancel('Another request has taken over.')
					this.cancelToken = null
				}

				this.cancelToken = this.axios.CancelToken.source()

				this.isLoading = true

				this.axios.get(`merchants/${this.activeMerchant.id}/subscriptions`, {
					params: {
						page: this.pagination.current_page,
						perPage: this.pagination.per_page,
						filter: 'inactive'
					}
				})
				.then(({data}) => {
					this.subscriptions = data.data
					this.pagination.per_page = data.per_page
					this.pagination.current_page = data.current_page
					this.pagination.total = data.total
					this.pagination.last_page = data.last_page
					this.isLoading = false
				})
				.catch(() => {
					this.$message.error('Something wen\'t wrong.')
					this.isLoading = false
				})
			},

			getInterval (pricing) {
				let interval = '-'

        if (pricing) {
          if (pricing.type === 'instant') {
            interval = this.$t('components.paymentplan.intervals.instant')
          } else if (pricing.type === 'recurring') {
            switch (pricing.interval) {
              case '1mo':
                interval = this.$t('components.paymentplan.intervals.monthly')
                break
              case '3mo':
                interval = this.$t('components.paymentplan.intervals.quarterly')
                break
              case '6mo':
                interval = this.$t('components.paymentplan.intervals.biannually')
                break
              case '1y':
                interval = this.$t('components.paymentplan.intervals.annually')
                break
            }
          }
        }

				return interval
			},

			gotoPage (pageNumber) {
				if (pageNumber !== this.pagination.current_page) {
					this.pagination.current_page = pageNumber
					this.fetchInactiveSubscriptions()
				}
			},

			gotoPrevPage () {
				if (this.pagination.current_page !== 1) {
					this.pagination.current_page = this.pagination.current_page - 1
					this.fetchInactiveSubscriptions()
				}
			},

			gotoNextPage () {
				if (this.pagination.current_page < this.pagination.last_page) {
					this.pagination.current_page = this.pagination.current_page + 1
					this.fetchInactiveSubscriptions()
				}
			},

			changePerPage (perPage) {
				this.pagination.per_page = perPage
				this.fetchInactiveSubscriptions()
			}
		},

		beforeDestroy () {
		}
	}
</script>

<style lang="scss" scoped>
	.ui.inverted.menu {
		background: none;
		border-bottom: 1px solid #d4d4d5;

		.blue.active.item {
			background-color: #00a9f7 !important;
		}

		.item:not(.active) {
			color: #000;
			background: #dadada;
			border-radius: .28571429rem .28571429rem 0 0 !important;

			&:hover {
				background: #adadad
			}
		}
	}

  .pagination.menu {
    flex-wrap: wrap;
    border: none;
    box-shadow: none;
    justify-content: center;

    .item {
      border-top: 1px solid rgba(34,36,38,.15);
      border-bottom: 1px solid rgba(34,36,38,.15);
      margin-top: -1px;

      &::before {
        left: 0;
        right: auto;
      }

      &::after {
        position: absolute;
        content: "";
        top: 0;
        right: -1px;
        height: 100%;
        width: 1px;
        background: rgba(34,36,38,.1);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/merchant/Archive.vue